import * as React from 'react';
import styles from './index.less';
// import { CSSProperties } from 'react';
// import { FUtil } from '@freelog/tools-lib';
// import url from '*.svg';

interface FNodeCoverImageProps {
  src: string;

  style?: React.CSSProperties;
  className?: string;
}

function FNodeCoverImage({ src, style = {}, className = '' }: FNodeCoverImageProps) {
  return <div className={styles.FNodeCoverImage} style={{ backgroundImage: `url(${src})` }} />;
}

export default FNodeCoverImage;
